"use strict";

var _interopRequireDefault = require("/www/wwwroot/python/front/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/python/front/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.search");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _role = require("@/api/role");
var _org = require("@/api/org");
var defaultRole = {
  id: "",
  name: "",
  description: "",
  perms: [],
  datas: "本级及以下",
  depts: []
};
var _default = exports.default = {
  data: function data() {
    return {
      search: "",
      role: Object.assign({}, defaultRole),
      routes: [],
      tableData: [],
      rolesList: [],
      dialogVisible: false,
      dialogType: "new",
      checkStrictly: true,
      listLoading: true,
      orgData: [],
      dataOptions: [{
        value: "全部",
        label: "全部"
      }, {
        value: "自定义",
        label: "自定义"
      }, {
        value: "同级及以下",
        label: "同级及以下"
      }, {
        value: "本级及以下",
        label: "本级及以下"
      }, {
        value: "本级",
        label: "本级"
      }, {
        value: "仅本人",
        label: "仅本人"
      }]
    };
  },
  computed: {},
  created: function created() {
    // Mock: get all routes and roles list from server
    this.getRoutes();
    this.getOrgAll();
    this.getRoleAll();
  },
  methods: {
    checkPermission: _permission.default,
    handleFilter: function handleFilter() {
      var _this = this;
      var newData = this.rolesList.filter(function (data) {
        return !_this.search || data.name.toLowerCase().includes(_this.search.toLowerCase());
      });
      this.tableData = (0, _utils.genTree)(newData);
    },
    getRoutes: function () {
      var _getRoutes2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _role.getRoutes)();
            case 2:
              res = _context.sent;
              // this.serviceRoutes = res.data
              this.routes = (0, _utils.genTree)(res.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getRoutes() {
        return _getRoutes2.apply(this, arguments);
      }
      return getRoutes;
    }(),
    getOrgAll: function () {
      var _getOrgAll2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _org.getOrgAll)();
            case 2:
              res = _context2.sent;
              this.orgData = (0, _utils.genTree)(res.data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getOrgAll() {
        return _getOrgAll2.apply(this, arguments);
      }
      return getOrgAll;
    }(),
    getRoleAll: function () {
      var _getRoleAll2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.listLoading = true;
              _context3.next = 3;
              return (0, _role.getRoleAll)();
            case 3:
              res = _context3.sent;
              this.tableData = res.data;
              this.rolesList = res.data;
              this.listLoading = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getRoleAll() {
        return _getRoleAll2.apply(this, arguments);
      }
      return getRoleAll;
    }(),
    handleAdd: function handleAdd() {
      this.role = Object.assign({}, defaultRole);
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedNodes([]);
      }
      this.dialogType = "new";
      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(scope) {
      var _this2 = this;
      this.dialogType = "edit";
      this.dialogVisible = true;
      this.role = (0, _utils.deepClone)(scope.row);
      this.$nextTick(function () {
        _this2.$refs.tree.setCheckedKeys(_this2.role.perms);
        _this2.$refs.depts_tree.setCheckedKeys(_this2.role.depts);
      });
    },
    handleDelete: function handleDelete(_ref) {
      var _this3 = this;
      var $index = _ref.$index,
        row = _ref.row;
      this.$confirm("确认删除?", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _role.deleteRole)(row.id);
            case 2:
              _this3.tableData.splice($index, 1);
              _this3.$message.success("成功");
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirmRole: function () {
      var _confirmRole = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var isEdit, index, _this$role, description, name;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              isEdit = this.dialogType === "edit";
              this.role.perms = this.$refs.tree.getCheckedKeys();
              if (this.role.datas === "自定义") {
                this.role.depts = this.$refs.depts_tree.getCheckedKeys();
              } else {
                this.role.depts = [];
              }
              if (!isEdit) {
                _context5.next = 16;
                break;
              }
              _context5.next = 6;
              return (0, _role.updateRole)(this.role.id, this.role);
            case 6:
              index = 0;
            case 7:
              if (!(index < this.tableData.length)) {
                _context5.next = 14;
                break;
              }
              if (!(this.tableData[index].id === this.role.id)) {
                _context5.next = 11;
                break;
              }
              this.tableData.splice(index, 1, Object.assign({}, this.role));
              return _context5.abrupt("break", 14);
            case 11:
              index++;
              _context5.next = 7;
              break;
            case 14:
              _context5.next = 20;
              break;
            case 16:
              this.role.perms = this.$refs.tree.getCheckedKeys();
              // const { data } = await createRole(this.role)
              _context5.next = 19;
              return (0, _role.createRole)(this.role);
            case 19:
              this.getRoleAll();
            case 20:
              _this$role = this.role, description = _this$role.description, name = _this$role.name;
              this.dialogVisible = false;
              this.$message.success("成功");
            case 23:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function confirmRole() {
        return _confirmRole.apply(this, arguments);
      }
      return confirmRole;
    }()
  }
};